import "./Items.css";

const Items = ({name,rprice,mprice,lprice}) => {
    return <div className="items_container">
        <div className="name">{name}</div>
        <div className="price">{rprice}</div>
        <div className="price">{mprice}</div>
        <div className="price">{lprice}</div>
    </div>;
}
 
export default Items;